import { SetStateAction } from "react";

import TextField, { TextFieldProps } from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

type FormFieldProps = TextFieldProps & {
    label: string;
};

type PasswordFieldProps = FormFieldProps & {
    showPassword: boolean;
    setShowPassword?: (value: SetStateAction<boolean>) => void;
};

export const FormField = ({ label, ...props }: FormFieldProps) => {
    return (
        <>
            <Typography mb={1} variant="body2">
                {label}
            </Typography>
            <TextField variant="outlined" size="small" fullWidth {...props} />
        </>
    );
};

export const PasswordField = ({
    showPassword,
    setShowPassword,
    ...props
}: PasswordFieldProps) => {
    return (
        <FormField
            type={showPassword ? "text" : "password"}
            InputProps={{
                endAdornment: setShowPassword && (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword!((prev) => !prev)}
                            size="small"
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
};
